<template>
  <div class="container-fluid py-4 statistics-view">
    <div v-if="isLoading" class="loading-overlay">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Caricamento...</span>
      </div>
      <div class="loading-text">Caricamento in corso...</div>
    </div>
    <div class="row mb-4">
      <div class="col-12 col-md-6"></div>

      <div class="col-12 col-md-6 d-flex gap-2 justify-content-end flex-wrap">

        <!-- Esperti -->
        <div class="dropdown filter-dropdown">
          <button class="btn btn-light border text-dark dropdown-toggle" data-bs-toggle="dropdown">
            {{ selectedExpertsLabel }}
          </button>
          <ul class="dropdown-menu p-2" style="max-height: 250px; overflow-y:auto;">
            <li v-for="e in allExperts" :key="e.id" class="form-check">
              <input class="form-check-input" type="checkbox" :value="e.id" v-model="selectedExperts">
              <label class="form-check-label ms-2">{{ e.surname }} {{ e.name }}</label>
            </li>
          </ul>
        </div>

        <!-- Articoli -->
        <div class="dropdown filter-dropdown">
          <button class="btn btn-light border text-dark dropdown-toggle article-btn" data-bs-toggle="dropdown">
            {{ selectedArticlesLabel }}
          </button>
          <ul class="dropdown-menu p-2" style="max-height: 250px; overflow-y:auto;">
            <li class="mb-2 px-2">
              <input type="text" class="form-control form-control-sm" placeholder="Cerca..." v-model="articleSearch">
            </li>
            <li v-for="a in filteredArticles" :key="a.id" class="form-check">
              <input class="form-check-input" type="checkbox" :value="a.id" v-model="selectedArticlesIds">
              <label class="form-check-label ms-2">
                {{ a.versions[a.versions.length - 1].title }}
              </label>
            </li>
          </ul>
        </div>

        <!-- Regioni -->
        <div class="dropdown filter-dropdown">
          <button class="btn btn-light border text-dark dropdown-toggle" data-bs-toggle="dropdown">
            {{ selectedRegionsLabel }}
          </button>
          <ul class="dropdown-menu p-2" style="max-height: 250px; overflow-y:auto;">
            <li v-for="r in allRegions" :key="r.id" class="form-check">
              <input class="form-check-input" type="checkbox" :value="r.id" v-model="filterRegion">
              <label class="form-check-label ms-2">{{ r.name }}</label>
            </li>
          </ul>
        </div>

        <!-- Anno o periodo personalizzato -->
        <div class="dropdown filter-dropdown">
          <select v-model="selectedPeriodType" @change="onPeriodTypeChange" class="form-select form-select-sm">
            <option v-for="y in dynamicYears" :key="y" :value="y">{{ y }}</option>
            <option value="custom">Periodo Personalizzato</option>
          </select>
        </div>

        <div v-if="selectedPeriodType === 'custom'" class="d-flex gap-1">
          <!--<input type="date" class="form-control form-control-sm" v-model="dateFrom" @change="fetchStats" />
          <input type="date" class="form-control form-control-sm" v-model="dateTo" @change="fetchStats" />-->
          <input type="date" class="form-control form-control-sm" v-model="dateFrom" />
          <input type="date" class="form-control form-control-sm" v-model="dateTo" />
        </div>

        <button class="btn btn-primary filter-btn" title="Applica filtri" @click="fetchStats" :disabled="selectedPeriodType === 'custom' && (!dateFrom || !dateTo)">
          <i class="bi bi-search"></i>
        </button>

        <button class="btn btn-outline-secondary filter-btn" title="Reset filtri" @click="resetFilters">
          <i class="bi bi-x-lg"></i>
        </button>

        <div class="dropdown">
          <button class="btn btn-outline-secondary btn-sm dropdown-toggle" data-bs-toggle="dropdown">
            <i class="bi bi-download me-1"></i> Esporta
          </button>

          <ul class="dropdown-menu dropdown-menu-end">
            <li><a class="dropdown-item" @click="exportPNG">PNG</a></li>
            <li><a class="dropdown-item" @click="exportCSV">CSV</a></li>
            <li><a class="dropdown-item" @click="exportExcelWithChart">XLSX</a></li>
          </ul>
        </div>
      </div>
    </div>
    <!-- ================= CARD 1: Stato Quesiti ================= -->
    <div class="card shadow-sm mb-4">
      <div class="card-body">
        <h5 class="fw-semibold mb-3">Stato Quesiti</h5>
        <div class="row text-center">
          <div v-for="item in statoQuesiti" :key="item.label" class="col">
            <div class="border rounded p-3 h-100">
              <div class="small text-muted">{{ item.label }}</div>
              <div class="fw-bold mt-1" :class="item.color" style="font-size: 1.9rem">
                {{ item.value }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ================= CARD 2: Statistiche Quesiti + Grafico ================= -->
    <div class="card shadow-sm mb-4">
      <div class="card-body">
        <h5 class="fw-semibold mb-3">Statistiche Quesiti</h5>

        <!-- KPI full width -->
        <div class="d-flex mb-3 gap-2">
          <div v-for="kpi in kpiTopComputed" :key="kpi.label" class="text-white rounded p-3 text-center"
            :style="{ backgroundColor: kpi.bg, flex: 1 }">
            <div class="fw-bold fs-4">{{ kpi.value }}</div>
            <div class="small">{{ kpi.label }}</div>
          </div>
        </div>

        <!-- Toggle grafico -->
        <div class="d-flex justify-content-center gap-2 mt-4 mb-3">
          <button class="btn chart-toggle" :class="{ active: chartMode === 'bar' }" @click="chartMode = 'bar'"
            title="Grafico a barre">
            <i class="bi bi-bar-chart-fill"></i>
          </button>
          <button class="btn chart-toggle" :class="{ active: chartMode === 'line' }" @click="chartMode = 'line'"
            title="Grafico a linee">
            <i class="bi bi-graph-up"></i>
          </button>
        </div>

        <!-- Grafico -->
        <VChart ref="chartRef" :option="chartOptions" style="height: 380px; width: 100%" />
      </div>
    </div>

    <!-- ================= CARD 3: Tempo medio ================= -->
    <div class="card shadow-sm">
      <div class="card-body">
        <h5 class="fw-semibold mb-4">Tempo di gestione medio</h5>

        <div v-for="barra in tempiGestione" :key="barra.label" class="mb-3">
          <div class="d-flex justify-content-between mb-1">
            <span>{{ barra.label }}</span>
            <span class="fw-semibold">{{ barra.value }} {{ barra.unit }}</span>
          </div>
          <div class="progress" style="height: 14px">
            <div class="progress-bar" role="progressbar"
              :style="{ width: (barra.value / barra.max * 100) + '%', backgroundColor: barra.color }">
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'
export default {
  name: 'StatisticsView',
  data() {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let i = 0; i <= 4; i++) years.push(currentYear - i);
    return {
      nuovi: [],
      scaduti: [],
      statoQuesiti: [],
      kpiTop: [],
      tempiGestione: [],
      chartMode: 'line',
      giorni: ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'],
      assegnati: [],
      evasi: [],
      totaleQuesiti: [],
      from: null,
      to: null,
      legalExpertId: null,
      countdownSettings: {
        days_1: 1,
        days_3: 3
      },
      allExperts: [],
      selectedExperts: [],

      availableArticles: [],
      selectedArticlesIds: [],
      articleSearch: '',

      allRegions: [],
      filterRegion: [],
      isLoading: true,
      articoloRilevanteId: null,
      selectedPeriodType: new Date().getFullYear(),
      dateFrom: null,
      dateTo: null,
      dynamicYears: Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i),
      graficoLabels: [],
    }
  },
  computed: {
    kpiTopComputed() {
      return this.kpiTop.map(kpi => {
        if (kpi.key === 'articolo') {
          return {
            ...kpi,
            value: this.articoloRilevanteId
              ? this.articoloRilevanteTitle
              : 'N/A'
          };
        }
        return kpi;
      });
    },
    articoloRilevanteTitle() {
      const articolo = this.availableArticles.find(
        a => a.id === this.articoloRilevanteId
      );

      return articolo
        ? articolo.versions.at(-1).title
        : 'N/A';
    },
    filteredArticles() {
      let articles = this.availableArticles.slice();
      if (this.articleSearch) {
        articles = articles.filter(a =>
          this.formatArticleTitle(a.versions[a.versions.length - 1].title)
            .toLowerCase()
            .includes(this.articleSearch.toLowerCase())
        );
      }
      return articles.sort((a, b) => a.id - b.id);
    },
    selectedExpertsLabel() {
      const count = this.selectedExperts.length;
      if (count === 0) return 'Esperti';
      if (count === 1) return this.allExperts.find(e => e.id === this.selectedExperts[0])?.surname || 'Esperto';
      return `Selezione multipla (${count})`;
    },
    selectedArticlesLabel() {
      const count = this.selectedArticlesIds.length;
      if (count === 0) return 'Articoli';
      if (count === 1) {
        const article = this.availableArticles.find(a => a.id === this.selectedArticlesIds[0]);
        return article ? article.versions[article.versions.length - 1].title : 'Articolo';
      }
      return `Selezione multipla (${count})`;
    },
    selectedRegionsLabel() {
      const count = this.filterRegion.length;
      if (count === 0) return 'Regioni';
      if (count === 1) return this.allRegions.find(r => r.id === this.filterRegion[0])?.name || 'Regione';
      return `Selezione multipla (${count})`;
    },
    selectedYearsLabel() {
      return this.selectedYear ? this.selectedYear : 'Anno';
    },
    dynamicYears() {
      const currentYear = new Date().getFullYear();
      return Array.from({ length: 5 }, (_, i) => currentYear - i); // ultimi 5 anni
    },
    chartOptions() {
      const isBar = this.chartMode === 'bar';
      return {
        tooltip: { trigger: 'axis' },
        legend: { data: ['Nuovi', 'Assegnati', 'Evasi', 'Scaduti'] },
        xAxis: { type: 'category', data: this.graficoLabels },
        yAxis: {
          type: 'value',
          min: 0,
          max: 'dataMax'
        },
        series: [
          {
            name: 'Nuovi',
            type: isBar ? 'bar' : 'line',
            data: this.nuovi,
            itemStyle: { color: '#0dcaf0' }
          },
          {
            name: 'Assegnati',
            type: isBar ? 'bar' : 'line',
            data: this.assegnati,
            itemStyle: { color: '#ffc107' }
          },
          {
            name: 'Evasi',
            type: isBar ? 'bar' : 'line',
            data: this.evasi,
            itemStyle: { color: '#198754' }
          },
          {
            name: 'Scaduti',
            type: isBar ? 'bar' : 'line',
            smooth: true,
            data: this.scaduti,
            itemStyle: { color: '#dc3545' }
          }
        ]
      }
    }
  },
  mounted() {
    //this.loadArticles();
    this.loadAllExperts();
    this.loadAllRegions();
    this.loadCountdownSettings();
    this.fetchStats();
  },
  watch: {
    '$root.contents.articles': {
      immediate: true,
      handler(val) {
        if (val && Object.keys(val).length) {
          this.loadArticles();
          this.fetchStats();
        }
      }
    },
    dateFrom() {
      if (this.selectedPeriodType === 'custom' && this.dateFrom && this.dateTo) {
        //this.fetchStats()
      }
    },
    dateTo() {
      if (this.selectedPeriodType === 'custom' && this.dateFrom && this.dateTo) {
        //this.fetchStats()
      }
    }
  },
  methods: {
    exportPNG() {
      const chart = this.getEchartsInstance()
      if (!chart) return

      const url = chart.getDataURL({
        type: 'png',
        pixelRatio: 2,
        backgroundColor: '#fff'
      })

      const link = document.createElement('a')
      link.href = url
      link.download = 'andamento_quesiti.png'
      link.click()
    },
    exportCSV() {
      let csv = 'ANDAMENTO QUESITI\nPeriodo;Nuovi;Assegnati;Evasi;Scaduti\n'

      this.graficoLabels.forEach((l, i) => {
        csv += `${l};${this.nuovi[i] ?? 0};${this.assegnati[i] ?? 0};${this.evasi[i] ?? 0};${this.scaduti[i] ?? 0}\n`
      })

      csv += '\nRIEPILOGO\nTipo;Valore\n'
      this.kpiTopComputed.forEach(k => {
        csv += `${k.label};${k.value}\n`
      })

      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      saveAs(blob, 'dashboard_quesiti.csv')
    },
    async exportExcelWithChart() {
      const chart = this.getEchartsInstance()
      if (!chart) return

      const chartDataUrl = chart.getDataURL({
        type: 'png',
        pixelRatio: 2,
        backgroundColor: '#fff'
      })

      const base64 = chartDataUrl.split(',')[1]
      const buffer = Uint8Array.from(atob(base64), c => c.charCodeAt(0))

      const wb = new ExcelJS.Workbook()
      const ws = wb.addWorksheet('Statistiche')

      ws.addRow(['ANDAMENTO QUESITI'])
      ws.addRow(['Periodo', 'Nuovi', 'Assegnati', 'Evasi', 'Scaduti'])

      this.graficoLabels.forEach((l, i) => {
        ws.addRow([
          l,
          this.nuovi[i] ?? 0,
          this.assegnati[i] ?? 0,
          this.evasi[i] ?? 0,
          this.scaduti[i] ?? 0
        ])
      })

      ws.addRow([])
      ws.addRow(['RIEPILOGO'])
      ws.addRow(['Tipo', 'Valore'])

      this.kpiTopComputed.forEach(k => {
        ws.addRow([k.label, k.value])
      })

      const imageId = wb.addImage({ buffer, extension: 'png' })
      ws.addImage(imageId, {
        tl: { col: 6, row: 1 },
        ext: { width: 1000, height: 260 }
      })

      const wbout = await wb.xlsx.writeBuffer()
      saveAs(new Blob([wbout]), 'dashboard_quesiti.xlsx')
    },
    getEchartsInstance() {
      return this.$refs.chartRef?.chart
    },
    onPeriodTypeChange() {
      if (this.selectedPeriodType !== 'custom') {
        this.dateFrom = null
        this.dateTo = null
        this.selectedYear = this.selectedPeriodType
        //this.fetchStats()
      }
    },
    resetFilters() {
      this.selectedExperts = [];
      this.selectedArticlesIds = [];
      this.filterRegion = [];
      const currentYear = new Date().getFullYear();
      this.selectedYear = currentYear;
      this.selectedPeriodType = currentYear;
      this.dateFrom = null;
      this.dateTo = null;

      this.fetchStats();
    },
    async loadAllExperts() {
      const res = await this.$root.$api.get('/users/legal');
      this.allExperts = res.data;
    },
    async loadAllRegions() {
      const res = await this.$root.$api.get('/questions/regions');
      this.allRegions = res.data;
    },
    loadArticles() {
      this.availableArticles = this.extractAllArticlesFromTree();
      console.log("articles" + this.availableArticles)
    },
    extractAllArticlesFromTree() {
      const all = this.$root.contents?.articles || {};
      return Object.values(all)
        .filter(a => !a.deleted_at && a.versions && a.versions.length > 0)
        .map(a => ({ id: a.id, versions: a.versions }));
    },
    async loadCountdownSettings() {
      try {
        const response = await this.$root.$api.get('/questions/countdown-settings');
        if (response.data.settings) {
          this.countdownSettings = response.data.settings;
        }
      } catch (error) {
        console.error('Errore caricamento impostazioni countdown', error);
      }
    },
    async fetchStats() {
      this.isLoading = true;
      try {
        //const params = { from: this.from, to: this.to, legal_expert_id: this.legalExpertId, days_1: this.countdownSettings.fourth_column_days, days_3: this.countdownSettings.third_column_days };
        const params = {
          legal_expert_id: this.selectedExperts.join(','),
          article_ids: this.selectedArticlesIds.join(','),
          region_ids: this.filterRegion.join(','),
          year: this.selectedYear,
          days_1: this.countdownSettings.fourth_column_days,
          days_3: this.countdownSettings.third_column_days
        };

        if (this.selectedPeriodType === 'custom' && this.dateFrom && this.dateTo) {
          params.from = this.dateFrom
          params.to = this.dateTo
        } else {
          params.year = this.selectedYear
        }
        const res = await this.$root.$api.get('/statistics/stats', { params });
        const data = res.data;

        // Stato quesiti
        this.statoQuesiti = [
          { label: 'Quesiti in lavorazione', value: data.stato_quesiti.in_lavorazione, color: '' },
          { label: 'Quesiti assegnati non in lavorazione', value: data.stato_quesiti.assegnati_non_in_lavorazione, color: '' },
          { label: 'Quesiti scaduti', value: data.stato_quesiti.scaduti, color: 'text-danger' },
          { label: `Quesiti in scadenza tra ${this.countdownSettings.fourth_column_days} giorno/i`, value: data.stato_quesiti.in_scadenza_1_giorno, color: 'text-warning' },
          { label: `Quesiti in scadenza tra ${this.countdownSettings.third_column_days} giorno/i`, value: data.stato_quesiti.in_scadenza_3_giorni, color: '' },
          { label: 'Quesiti non assegnati', value: data.stato_quesiti.non_assegnati, color: '' }
        ];

        // KPI top
        this.kpiTop = [
          { label: 'Nuovi quesiti', value: data.stats_quesiti.nuovi, bg: '#0dcaf0' },
          { label: 'Quesiti assegnati', value: data.stats_quesiti.assegnati, bg: '#ffc107' },
          { label: 'Quesiti evasi', value: data.stats_quesiti.evasi, bg: '#198754' },
          { label: 'Quesiti scaduti', value: data.stats_quesiti.scaduti, bg: '#dc3545' },
          //{ label: 'Articolo rilevante', value: 'Art. ' + data.stats_quesiti.articolo_rilevante, bg: '#6c757d' }
          {
            label: 'Articolo rilevante',
            value: null,
            bg: '#6c757d',
            key: 'articolo'
          }
        ];

        // Tempi gestione
        this.tempiGestione = [
          {
            label: 'Tempo medio di assegnazione',
            value: data.tempo_medio_prima_assegnazione_ore,
            unit: 'giorni',
            max: 60,
            color: '#ffc107'
          },
          {
            label: 'Tempo medio di presa in carico',
            value: data.tempo_medio_presa_in_carico_ore,
            unit: 'giorni',
            max: 60,
            color: '#198754'
          },
          {
            label: 'Tempo medio di evasione',
            value: data.tempo_medio_evasione_giorni,
            unit: 'giorni',
            max: 60,
            color: '#0d6efd'
          }
        ];

        this.articoloRilevanteId = data.stats_quesiti.articolo_rilevante;
        const articolo = this.availableArticles.find(a => a.id === this.articoloRilevanteId);
        this.articoloRilevanteTitle = articolo ? articolo.versions[articolo.versions.length - 1].title : 'N/A';
        this.graficoLabels = data.grafico.labels || [];
        this.nuovi = data.grafico.nuovi || [];
        this.assegnati = data.grafico.assegnati || [];
        this.evasi = data.grafico.evasi || [];
        this.scaduti = data.grafico.scaduti || [];

      } catch (err) {
        console.error('Errore fetchStats:', err);
      }
      finally {
        this.isLoading = false;
      }
    }
  }
}
</script>

<style scoped>
.chart-toggle {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid #0d6efd;
  color: #0d6efd;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease-in-out, transform 0.15s ease-in-out;
}

.chart-toggle:hover {
  background-color: rgba(13, 110, 253, 0.1);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.chart-toggle.active {
  background-color: #0d6efd;
  color: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  transform: translateY(-1px);
}

.chart-toggle.active i {
  transform: scale(1.1);
  transition: transform 0.15s ease-in-out;
}

.dropdown {
  min-width: 6rem;
}

/** .dropdown .dropdown-menu {
  min-width: 17rem;
  max-width: 20rem;
  width: auto;
}*/

.filter-dropdown .btn,
.filter-dropdown select.form-select {
  min-height: 2rem;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  max-height: 2rem;
}

.filter-dropdown .dropdown-menu {
  max-height: 2rem;
  /* mantiene lo scroll verticale */
  overflow-y: auto;
  width: 220px;
  /* stessa larghezza massima per tutti */
}

.filter-btn {
  width: 32px;
  height: 32px;
  min-height: 2rem;
  padding: 0;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.article-btn {
  max-width: 220px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.loading-text {
  margin-top: 1rem;
  font-weight: bold;
  color: #0d6efd;
}

.statistics-view .card .fw-bold {
  font-size: 1.3rem !important;
}
</style>
